export const QUESTION_TYPES = {
  multipleChoice: 'questions/multiple_choice',
  freeResponse: 'questions/free_response',
  mcq: 'questions/multiple_choice',
  frq: 'questions/free_response',
};

export const NOT_OPENED_ASSIGNMENT_ERROR_MESSAGE =
  '403 Forbidden: Assignment is not opened';
export const SUBMITTED_BY_TEACHER_ERROR_MESSAGE =
  '403 Forbidden: Assignment was submitted by teacher';
